import { Table, Badge, Card } from 'evergreen-ui';
import { formatDeviceInfo } from '../utils/parseUserAgent';
import useWindowSize from '../utils/useWindowSize';
import '../styles/responsive.css';

const formatDateTime = (value) => {
    const d = new Date(value.replace(' ', 'T'));
    if (isNaN(d.getTime())) return value;
    return d.toLocaleString('it-IT', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
};

const collaboratorLabel = (entry) => (
    entry.user_id
        ? `${entry.nome} ${entry.cognome}`
        : <Badge color="red">Account rimosso ({entry.nome} {entry.cognome})</Badge>
);

const LoginHistoryTable = ({ entries }) => {
    const width = useWindowSize();
    const isMobile = width < 768;

    if (isMobile) {
        return (
            <div className="responsive-list">
                {entries.length > 0 ? entries.map(entry => (
                    <Card key={entry.id} className="responsive-card">
                        <div className="field-row">
                            <div className="field-label">Data/ora</div>
                            <div className="field-value">{formatDateTime(entry.created_at)}</div>
                        </div>
                        <div className="field-row">
                            <div className="field-label">Collaboratore</div>
                            <div className="field-value">{collaboratorLabel(entry)}</div>
                        </div>
                        <div className="field-row">
                            <div className="field-label">Email</div>
                            <div className="field-value">{entry.email}</div>
                        </div>
                        <div className="field-row">
                            <div className="field-label">IP</div>
                            <div className="field-value">{entry.ip_address}</div>
                        </div>
                        <div className="field-row">
                            <div className="field-label">Dispositivo</div>
                            <div className="field-value">{formatDeviceInfo(entry.user_agent)}</div>
                        </div>
                    </Card>
                )) : (
                    <Card className="responsive-card">Nessun accesso registrato.</Card>
                )}
            </div>
        );
    }

    return (
        <div style={{ overflowX: 'auto' }}>
            <Table minWidth={640}>
                <Table.Head>
                    <Table.TextHeaderCell>Data/ora</Table.TextHeaderCell>
                    <Table.TextHeaderCell>Collaboratore</Table.TextHeaderCell>
                    <Table.TextHeaderCell>Email</Table.TextHeaderCell>
                    <Table.TextHeaderCell>IP</Table.TextHeaderCell>
                    <Table.TextHeaderCell>Dispositivo</Table.TextHeaderCell>
                </Table.Head>
                <Table.Body>
                    {entries.map(entry => (
                        <Table.Row key={entry.id}>
                            <Table.TextCell>{formatDateTime(entry.created_at)}</Table.TextCell>
                            <Table.TextCell>{collaboratorLabel(entry)}</Table.TextCell>
                            <Table.TextCell>{entry.email}</Table.TextCell>
                            <Table.TextCell>{entry.ip_address}</Table.TextCell>
                            <Table.TextCell>{formatDeviceInfo(entry.user_agent)}</Table.TextCell>
                        </Table.Row>
                    ))}
                </Table.Body>
            </Table>
        </div>
    );
};

export default LoginHistoryTable;
